import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';
import produce from 'immer';
import * as kioskProductAPI from '../../lib/api/kioskProduct';
import { sortReverse } from '../../lib/commonFunc/commonFunc';

const INITIALIZE = 'kioskProduct/INITIALIZE';
const INIT_RES = 'kioskProduct/INIT_RES';

const [
  LOAD_ALL_KIOSK_PRODUCT,
  LOAD_ALL_KIOSK_PRODUCT_SUCCESS,
  LOAD_ALL_KIOSK_PRODUCT_FAILURE,
] = createRequestActionTypes('kioskProduct/LOAD_ALL_KIOSK_PRODUCT');

const [
  DELETE_KIOSK_PRODUCT,
  DELETE_KIOSK_PRODUCT_SUCCESS,
  DELETE_KIOSK_PRODUCT_FAILURE,
] = createRequestActionTypes('kioskProduct/DELETE_KIOSK_PRODUCT');

const [
  CHANGE_KIOSK_PRODUCT_ACTIVE,
  CHANGE_KIOSK_PRODUCT_ACTIVE_SUCCESS,
  CHANGE_KIOSK_PRODUCT_ACTIVE_FAILURE,
] = createRequestActionTypes('kioskProduct/CHANGE_KIOSK_PRODUCT_ACTIVE');

const [
  CHANGE_KIOSK_PRODUCT_STATE,
  CHANGE_KIOSK_PRODUCT_STATE_SUCCESS,
  CHANGE_KIOSK_PRODUCT_STATE_FAILURE,
] = createRequestActionTypes('kioskProduct/CHANGE_KIOSK_PRODUCT_STATE');

const [
  CHANGE_KIOSK_PRODUCT_ORDER,
  CHANGE_KIOSK_PRODUCT_ORDER_SUCCESS,
  CHANGE_KIOSK_PRODUCT_ORDER_FAILURE,
] = createRequestActionTypes('kioskProduct/CHANGE_KIOSK_PRODUCT_ORDER');

const [
  MODIFY_KIOSK_PRODUCT,
  MODIFY_KIOSK_PRODUCT_SUCCESS,
  MODIFY_KIOSK_PRODUCT_FAILURE,
] = createRequestActionTypes('kioskProduct/MODIFY_KIOSK_PRODUCT');

export const modifyKioskProduct = createAction(
  MODIFY_KIOSK_PRODUCT,
  ({ clubID, socketKey, clubKioskSalesItemData, isNew }) => ({
    clubID,
    socketKey,
    clubKioskSalesItemData,
    isNew
  }),
);

export const changeKioskProductOrder = createAction(
  CHANGE_KIOSK_PRODUCT_ORDER,
  ({ clubID, clubKioskSalesItemID, direction, socketKey }) => ({
    clubID,
    clubKioskSalesItemID,
    direction,
    socketKey
  }),
);

export const changeKioskProductState = createAction(
  CHANGE_KIOSK_PRODUCT_STATE,
  ({ clubID, kioskProductState, socketKey }) => ({
    clubID,
    kioskProductState,
    socketKey
  }),
);

export const loadAllKioskProduct = createAction(
  LOAD_ALL_KIOSK_PRODUCT,
  ({ clubID, socketKey }) => ({
    clubID,
    socketKey
  }),
);

export const deleteKioskProduct = createAction(
  DELETE_KIOSK_PRODUCT,
  ({ clubID, clubKioskSalesItemID, socketKey }) => ({
    clubID,
    clubKioskSalesItemID,
    socketKey
  }),
);

export const changeKioskProductActive = createAction(
  CHANGE_KIOSK_PRODUCT_ACTIVE,
  ({ clubID, clubKioskSalesItemID, isActive, socketKey }) => ({
    clubID,
    clubKioskSalesItemID,
    isActive,
    socketKey
  }),
);

export const init = createAction(INITIALIZE)
export const initRes = createAction(INIT_RES)

const changeKioskProductOrderSaga = createRequestSaga(CHANGE_KIOSK_PRODUCT_ORDER, kioskProductAPI.changeKioskProductOrder);
const changeKioskProductStateSaga = createRequestSaga(CHANGE_KIOSK_PRODUCT_STATE, kioskProductAPI.changeKioskProductState);
const loadAllKioskProductSaga = createRequestSaga(LOAD_ALL_KIOSK_PRODUCT, kioskProductAPI.loadKioskProductAll);
const deleteKioskProductSaga = createRequestSaga(DELETE_KIOSK_PRODUCT, kioskProductAPI.deleteKioskProduct);
const changeKioskProductActiveSaga = createRequestSaga(CHANGE_KIOSK_PRODUCT_ACTIVE, kioskProductAPI.changeKioskProductActive);
const modifyKioskProductSaga = createRequestSaga(MODIFY_KIOSK_PRODUCT, kioskProductAPI.modifyKioskProduct);

export function* kioskProductSaga() {
  yield takeLatest(CHANGE_KIOSK_PRODUCT_ORDER, changeKioskProductOrderSaga);
  yield takeLatest(CHANGE_KIOSK_PRODUCT_STATE, changeKioskProductStateSaga);
  yield takeLatest(LOAD_ALL_KIOSK_PRODUCT, loadAllKioskProductSaga);
  yield takeLatest(DELETE_KIOSK_PRODUCT, deleteKioskProductSaga);
  yield takeLatest(CHANGE_KIOSK_PRODUCT_ACTIVE, changeKioskProductActiveSaga);
  yield takeLatest(MODIFY_KIOSK_PRODUCT, modifyKioskProductSaga);
}

const initialState = {
  error: null,
  stateChangeRes: null,
  kioskProductList: [],
  loadRes: null,
  deleteRes: null,
  activeRes: null,
  modifyRes: null,
};

const kioskProduct = handleActions(
  {
    [INITIALIZE]: () => initialState,
    [INIT_RES]: (state) => ({
      ...state,
      loadRes: null,
      deleteRes: null,
      activeRes: null,
      error: null,
      stateChangeRes: null,
    }),
    [CHANGE_KIOSK_PRODUCT_ORDER_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      kioskProductList: sortReverse(res.infos.map((item) => {
        let photoArr = item.images.split('%&')
        let memoArr = []
        if(item.memos && item.memos !== "") memoArr = item.memos.split('%&')

        return item={
        ...item,
        images: photoArr,
        memos: memoArr,
      }
    }), 'order'),
    }),
    [CHANGE_KIOSK_PRODUCT_ORDER_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error
    }),
    [CHANGE_KIOSK_PRODUCT_STATE]: (state) => ({
      ...state,
    }),
    [CHANGE_KIOSK_PRODUCT_STATE_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      stateChangeRes: res.result,
    }),
    [CHANGE_KIOSK_PRODUCT_STATE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error
    }),
    [LOAD_ALL_KIOSK_PRODUCT_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      kioskProductList: sortReverse(res.infos.map((item) => {
          let photoArr = item.images.split('%&')
          let memoArr = []
          if(item.memos && item.memos !== "") memoArr = item.memos.split('%&')

          return item={
          ...item,
          images: photoArr,
          memos: memoArr,
        }
      }), 'order'),
      loadRes: res.result
    }),
    [LOAD_ALL_KIOSK_PRODUCT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error
    }),
    [DELETE_KIOSK_PRODUCT]: (state) => ({
      ...state,
    }),
    [DELETE_KIOSK_PRODUCT_SUCCESS]: (state, { payload: res }) => ({
      ...state,
     deleteRes: res.result
    }),
    [DELETE_KIOSK_PRODUCT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error
    }),
    [CHANGE_KIOSK_PRODUCT_ACTIVE]: (state) => ({
      ...state,
    }),
    [CHANGE_KIOSK_PRODUCT_ACTIVE_SUCCESS]: (state, { payload: res }) => ({
      ...state,
     activeRes: res.result
    }),
    [CHANGE_KIOSK_PRODUCT_ACTIVE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error
    }),
    [MODIFY_KIOSK_PRODUCT]: (state) => ({
      ...state,
    }),
    [MODIFY_KIOSK_PRODUCT_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      modifyRes: res.result
    }),
    [MODIFY_KIOSK_PRODUCT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error
    }),
  },
  initialState,
);

export default kioskProduct;

